// Utility
// Version number
export const VERSION_NUMBER = "2.01";

// Remove symbol(
export const returnSymbolString = (string) => {
  const partString = string.split("(");
  let newWord = [];
  for (let i = 1; i < partString.length; i++) {
    newWord = (partString[i].split(')')[0]);
  }
  return newWord;
}

// Trasforma il formato dei numeri in un formato con due zeri, più leggibile per l'utente finale
export const NumberWithCommas = (x) => {
  let str = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  str = str.replace(/\.(?=[^.]*$)/, ",");
  return str;
}